/* -------------------------------------------------------------------------- */
/*                                Option styles                */
/* -------------------------------------------------------------------------- */

@import './bq-option.variables';

:host {
  @apply block;
}

:host([hidden]) {
  @apply hidden;
}

.bq-option {
  @apply flex cursor-pointer items-center text-[length:--bq-option--font-size] text-primary is-full;
  @apply p-b-[--bq-option--paddingY] p-i-[--bq-option--paddingY];
  @apply rounded-[--bq-option--border-radius] bg-[--bq-option--background] shadow-[shadow:--bq-option--box-shadow];
  @apply border-[length:--bq-option--border-width] border-[color:--bq-option--border-color];
  // Transition
  @apply transition-colors duration-150 ease-in-out;
  // Focus
  @apply enabled:focus-visible:focus;
  // Hover
  @apply enabled:hover:bg-hover-ui-secondary;
  // Active
  @apply enabled:[&.active]:bg-ui-brand-alt enabled:[&.active]:text-brand;
  // Disabled
  @apply disabled:cursor-not-allowed disabled:opacity-60;

  border-style: var(--bq-option--border-style);
}

.bq-option__label {
  @apply inline-block flex-auto overflow-hidden text-ellipsis text-start whitespace-nowrap;
  @apply pe-[--bq-option-label--padding-end] ps-[--bq-option-label--padding-start];
}
